/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var getDataProp = function getDataProp(propName) {
  if (propName == null) {
    return null;
  }
  return function (item) {
    if (!item) {
      return null;
    }
    return typeof propName === 'function' ? propName(item) : item[propName];
  };
};
var _default = getDataProp;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/ComboBox/src/utils/getDataProp.js
// module id = 661
// module chunks = 0